













import {Component, Prop, Vue} from 'vue-property-decorator'
import {TWalletNetwork} from '@/model/wallets/types/WalletNetwork'
import {siteNetwork} from '@/helpers/NetworkModeRegistry'

@Component
export default class ConnectWalletNetworkBadge extends Vue {
  @Prop({type: String, required: true}) walletImplementation!: 'n3' | 'neoX'
  @Prop({type: String, default: undefined}) targetNetwork?: TWalletNetwork

  get network(): TWalletNetwork {
    return this.targetNetwork ?? siteNetwork()
  }

  get isTestnet(): boolean {
    return this.network === 'testnet'
  }
}
